import { BaseNotification } from '@notify/models/notification/types/base';
import { DocumentsUpdate } from '@notify/models/notification/types/documents-update';
import { LowBalance } from '@notify/models/notification/types/low-balance';
import { RatesUpdate } from '@notify/models/notification/types/rates-update';
import { SendersUpdate } from '@notify/models/notification/types/senders-update';
import { MailingsUpdate } from '@notify/models/notification/types/mailings_update';
import { Custom } from '@notify/models/notification/types/custom';
import { DatabaseExportComplete } from '@notify/models/notification/types/database-export-complete';
import { MailingExportComplete } from '@notify/models/notification/types/mailing-export-complete';
import { VoiceExportComplete } from '@notify/models/notification/types/voice-export-complete';
import { InformerExportComplete } from '@notify/models/notification/types/informer-export-complete';
import { RecordingExportComplete } from '@notify/models/notification/types/recording-export-complete';
import DefaultNotification from '@notify/models/notification/types/default-notification';

export const MAP_NOTIFICATION_TYPES = {
  database_export_complete: 'database_export_complete',
  mailing_export_complete: 'mailing_export_complete',
  voice_export_complete: 'voice_export_complete',
  recording_export_complete: 'recording_export_complete',
  informer_export_complete: 'stat_export_complete',
  predictive_export_stats_complete: 'predictive_export_stats_complete',
  senders_update: 'senders_update',
  mailings_update: 'mailings_update',
  not_enough_money: 'not_enough_money'
};

const MAP_TYPE_TO_CLASS = {
  rates_update: RatesUpdate,
  documents_update: DocumentsUpdate,
  low_balance: LowBalance,
  custom: Custom,
  [MAP_NOTIFICATION_TYPES.senders_update]: SendersUpdate,
  [MAP_NOTIFICATION_TYPES.mailings_update]: MailingsUpdate,
  [MAP_NOTIFICATION_TYPES.database_export_complete]: DatabaseExportComplete,
  [MAP_NOTIFICATION_TYPES.mailing_export_complete]: MailingExportComplete,
  [MAP_NOTIFICATION_TYPES.voice_export_complete]: VoiceExportComplete,
  [MAP_NOTIFICATION_TYPES.recording_export_complete]: RecordingExportComplete,
  [MAP_NOTIFICATION_TYPES.informer_export_complete]: InformerExportComplete,
  [MAP_NOTIFICATION_TYPES.not_enough_money]: DefaultNotification,
  [MAP_NOTIFICATION_TYPES.predictive_export_stats_complete]: DatabaseExportComplete,
};

export class Notification {
  constructor(params) {
    const { type } = params;

    try {
      return new MAP_TYPE_TO_CLASS[type](params);
    } catch (e) {
      console.error('Unknown notification type', type);
      return new BaseNotification(params);
    }
  }
}
